import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'

const SizesSelector = ({
  ...props,
}) => {
  return (
    <FormSelect
      label="Sizes"
      {...props}
      options={
        [
          'mini',
          'tiny',
          'small',
          'medium',
          'large',
          'big',
          'huge',
          'massive',
        ]
      }
    />
  )
}

SizesSelector.propTypes = {}
SizesSelector.defaultProps = {}

export default SizesSelector



// WEBPACK FOOTER //
// ./src/components/forms/SizesSelector.js